import { z } from 'zod';

import { zodDateOrString } from '../utils/Zod';

export const EscrowPaymentHistoryItemApi = z.object({
  id: z.string(),
  type: z.enum(['initial', 'manualUpdate', 'api', 'csv', 'shortagePayment', 'analysis', 'constructionToPermanent']),
  amount: z.number(),
  effectiveDate: zodDateOrString.optional(),
  createdAt: zodDateOrString,
  status: z.enum(['active', 'cancelled']).optional(),
});
export type EscrowPaymentHistoryItemApi = z.infer<typeof EscrowPaymentHistoryItemApi>;
